import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// A slim animated progress bar pinned to the very top of the screen that runs
// on EVERY route / menu change. The Suspense skeleton only shows while a lazy
// chunk downloads (first visit) — a cached page switches instantly with no
// feedback, so the user couldn't tell the page had changed. This bar always
// gives that "something happened" cue: it shoots up, holds, then completes and
// fades. Pure UI, no data, mounted once inside the router.
export default function TopRouteProgress() {
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    // Clear any run still in flight so rapid clicks restart cleanly.
    timers.current.forEach(clearTimeout);
    timers.current = [];

    setVisible(true);
    setProgress(12);
    timers.current.push(setTimeout(() => setProgress(62), 80));
    timers.current.push(setTimeout(() => setProgress(85), 260));
    timers.current.push(setTimeout(() => setProgress(100), 520));
    // Fade out once full, then reset for the next navigation.
    timers.current.push(setTimeout(() => setVisible(false), 820));
    timers.current.push(setTimeout(() => setProgress(0), 1050));

    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
  }, [location.pathname]);

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: 3,
        zIndex: 2000,
        pointerEvents: 'none',
        opacity: visible ? 1 : 0,
        transition: 'opacity .25s ease',
      }}>
      <div
        style={{
          height: '100%',
          width: `${progress}%`,
          background: 'linear-gradient(90deg,#1A56DB,#3B82F6,#22D3EE)',
          boxShadow: '0 0 8px rgba(59,130,246,.7)',
          borderRadius: '0 2px 2px 0',
          transition: 'width .3s ease',
        }}
      />
    </div>
  );
}
